/************************************** Module ***********************************************/
import angular from 'angular';
import "reflect-metadata";
import 'angular-translate';

/************************************** Less ***********************************************/
import './card-print-type.less';
import 'bootstrap/dist/css/bootstrap.css';

/************************************** Module ***********************************************/
import { module_name as qpPictureLoading } from "../../../../directives/qp-picture-loading/qp-picture-loading.module";

let pageModule = angular.module("card-print-type-page", [qpPictureLoading, 'pascalprecht.translate']);
